module.exports = __webpack_public_path__ + "img/wtb12.5780d1ec.png";